import {combineReducers} from "redux";
import pageName from "./pagesinfo";
import schedule from "./schedule";
import game from "./game";
import home from "./home";

const rootReducers = combineReducers({
	//static data from project
	pages: state => state || {},
	Client: state => state || {},
	Config: state => state || {},
	Project: state => state || {},

	//update data from page logic
	pageName,
	schedule,
	game,
	home,
});

export default rootReducers;